import "./Footer.css";

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      <div className="footer-top">
        <div className="footer-logos">
          <img
            src="/images/edhec-climate-institute.png"
            alt="EDHEC Climate Institute"
            className="footer-logo-img"
          />
          <div className="footer-logo-sep" />
          <img
            src="/images/climate-innov.png"
            alt="Climate Innov"
            className="footer-logo-img"
          />
        </div>
        <div className="footer-contact">
          <span className="footer-url">www.ensemblepourlaforet.fr</span>
          {/* <a href="mailto:info@ensemblepourlaforet.fr" className="footer-email">
            info@ensemblepourlaforet.fr
          </a> */}

          <a
            href="https://www.instagram.com/ensemblefaceauclimat/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-instagram"
          >
            <img
              src="/images/Instagram.png"
              alt="Instagram"
              className="footer-instagram-icon"
            />
    <span>Instagram</span>
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <a href="/mentions-legales" className="footer-legal-link">
          Mentions légales
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
